import {shortRhythm} from './metronome.js';
// Keep each announcement/cue intact, including the rhythm inside multi-tone cues.
// Use measured events from the original plan so calculated speech keeps workout values.
export function compactAudioSchedule(workout, plan) {
  const groups = new Map();
  for (const event of plan.events) {
    const key = event.group ?? event.occurrence;
    let group = groups.get(key);
    if (!group) groups.set(key, group = {start:event.at, end:event.end, events:[]});
    group.start = Math.min(group.start, event.at);
    group.end = Math.max(group.end, event.end);
    group.events.push(event);
  }
  for(const stream of plan.rhythms??[]){const {stream:sample,seconds}=shortRhythm(stream);groups.set(stream.occurrence,{start:stream.start,end:stream.start+seconds,events:[],sample});}
  const events = [],rhythms=[];
  let total = 0;
  for (const group of [...groups.values()].sort((a,b)=>a.start-b.start)) {
    const shift = total - group.start;
    if(group.sample)rhythms.push({...group.sample,start:total,end:total+group.sample.end,first:total});
    for (const event of group.events) events.push({...event, at:event.at+shift, end:event.end+shift});
    total += group.end-group.start;
  }
  if (total <= 0) throw Error('Add Speech or Audio Cue events, or a Swim Metronome, to generate a compact audio test.');
  return {total, events, rhythms, controls:[], pauses:[], spans:[], settings:{fade:workout.fade,volume:1,cueVolume:1}};
}
